import { APIModel } from './api-model.model'

export class APIProduct extends APIModel {
    productId: number;
    productName: string;
    productPeriodicity: number;
    productQuietTimeEnabled: number;
    providerId: number;
    shortcodeId: number;
    productEnabled: number;
    productMaxDailySubs: number;
    productMaxMonthlySubs: number;
    productRetationDays: number;
    productFreeTrial: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        productId: number;
        productName: string;
        productPeriodicity: number;
        productQuietTimeEnabled: number;
        providerId: number;
        shortcodeId: number;
        productEnabled: number;
        productMaxDailySubs: number;
        productMaxMonthlySubs: number;
        productRetationDays: number;
        productFreeTrial: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.productId = params.productId
        this.productName = params.productName
        this.productPeriodicity = params.productPeriodicity
        this.providerId = params.providerId
        this.shortcodeId = params.shortcodeId
        this.productQuietTimeEnabled = params.productQuietTimeEnabled ? 1 : 0
        this.productEnabled = params.productEnabled ? 1 : 0
        this.productMaxDailySubs = params.productMaxDailySubs
        this.productRetationDays = params.productRetationDays
        this.productMaxMonthlySubs = params.productMaxMonthlySubs
        this.productFreeTrial = params.productFreeTrial
    }
}
